import { toPlatePlugin } from '@udecode/plate/react';

import { BaseTextIndentPlugin } from '../lib';

export const TextIndentPlugin = toPlatePlugin(BaseTextIndentPlugin);
